import { render } from "./InstanceForm.vue?vue&type=template&id=ba3a36bc&scoped=true"
import script from "./InstanceForm.vue?vue&type=script&lang=js"
export * from "./InstanceForm.vue?vue&type=script&lang=js"

import "./InstanceForm.vue?vue&type=style&index=0&id=ba3a36bc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba3a36bc"]])

export default __exports__